//
//
//
//
//
//

export default {
  props: {
    languages: {
      type: [String, Array],
      default() {},
    },
  },

  computed: {
    translatedLanguages() {
      return Array.isArray(this.languages)
        ? this.languages?.map((lang) => this.$translation(`languages.${lang}`))
        : this.$translation(`languages.${this.languages}`)
    },
    hint() {
      const languagesString = Array.isArray(this.translatedLanguages)
        ? this.translatedLanguages.join(', ')
        : this.translatedLanguages

      let hint = languagesString

      hint = hint
        .replaceAll(' ', '&nbsp;') // no line breaks at spaces
        .replaceAll('.&nbsp;', '. ')

      return hint
    },
  },

  watch: {
    '$i18n.locale': {
      immediate: true,
      handler(lang) {
        const speakingLang = lang.split('_')[0].toUpperCase()
        this.showHint = !this.languages.includes(speakingLang)
      },
    },
  },
}
